<ion-list class="content-width">
  @for (owner of venue().owners; track $index) {
    <ion-item>
      <ion-avatar slot="start">
        @if (owner?.profile_image) {
          <img [src]="owner.profile_image" alt="Profile Image" />
        } @else {
          <ion-icon name="person-circle-outline" size="large"></ion-icon>
        }
      </ion-avatar>

      <ion-checkbox [checked]="isAdminChecked(owner._id)" (ionChange)="selectAdmins($event, owner._id)" justify="space-between">
        {{ owner.first_name }} {{ owner.last_name }}
      </ion-checkbox>
    </ion-item>
  }

  <ion-button class="ion-margin" (click)="addAdminByPhone()" expand="block" fill="clear" color="primary">
    {{'Add administrators' | translate}}
  </ion-button>
</ion-list>

@if (selectedAdmins.length) {
  <ion-footer class="content-width">
    <ion-toolbar>
      <ion-button class="ion-margin" (click)="deleteAdmins()" expand="block" color="danger">
        {{'Delete Administrators' | translate}}
      </ion-button>
    </ion-toolbar>
  </ion-footer>
}